import React from 'react';
import TrackingId from '../../Tracking/TrackingId';
import './style.scss';

const TrackingCard = (props) => {
    const user = props.auth.user;
    const account = user?.activeAccount;

    return (

        <div className="card tracking-card card-panel">

            {!account && <div className="select-account">Please select an active account.</div>}

            {account &&

                <div className="tracking-wrapper">

                    {<TrackingId auth={props.auth} user={user} />}

                    {/* { error != '' && <div className="status error">{error}</div> } */}

                </div>

            }

        </div>
    );
}

export default TrackingCard;